export const IMAGE_PLACEHOLDER_SRC = '/logo.png';

export const applyImageFallback = (event) => {
  const image = event.currentTarget;
  if (image.dataset.fallbackApplied === 'true') return;
  image.dataset.fallbackApplied = 'true';
  image.src = IMAGE_PLACEHOLDER_SRC;
  image.style.objectFit = 'contain';
  image.style.background = '#f4efe6';
};